import React from "react";
import _ from "underscore";
import ActionLogger from "action-logger";
import { membershipLens } from "rtr-constants";
import ProductsActions from "actions/products-actions";
import PropTypes from "prop-types";
import Routes from "routes";
import RentalOptionIntent, { RentalOptions, ActionsTaken } from "helpers/rental-option-intent-helper";
import { productIsHomeGood } from "helpers/homegood-helpers";
import { addQueryParam } from "../../../helpers/location-helpers";

export const propTypes = {
  addToBagUrl: PropTypes.string,
  cta: PropTypes.string,
  dek: PropTypes.string,
  dispatch: PropTypes.func,
  hasSkuInBag: PropTypes.bool,
  list: PropTypes.arrayOf(PropTypes.string),
  loggingLocation: PropTypes.string.isRequired, // "drawer" or "pdp"
  membershipType: PropTypes.string.isRequired, // "membership" or "rtr_update" or "unlimited"
  primaryCtaAddsToBag: PropTypes.bool,
  primaryCtaUrl: PropTypes.string,
  product: PropTypes.object.isRequired,
  promo: PropTypes.string,
  secondaryCta: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
};

export const defaultProps = {
  primaryCtaAddsToBag: true,
};

export default class MembershipAcquisitionMessaging extends React.Component {
  logInferAction(object, action) {
    ActionLogger.inferAction({
      object_type: object,
      action: action,
      style_name: this.props.product.id,
    });
  }

  handleLogInferTryMembership = () => {
    const logObjectType = "cta_click";
    const logActionType = `${this.props.membershipType}_${this.props.loggingLocation}`;

    this.logInferAction(logObjectType, logActionType);
  };

  handleLogInferCheckoutWithSku = () => {
    const logObjectType = `${this.props.membershipType}_${this.props.loggingLocation}`;
    const logActionType = "checkout_4_items";

    this.logInferAction(logObjectType, logActionType);
  };

  handleLogInferLearnMore = () => {
    const logObjectType = `${this.props.membershipType}_${this.props.loggingLocation}`;
    const logActionType = `click_learn_more_${this.props.membershipType}`;

    this.logInferAction(logObjectType, logActionType);
  };

  handleLogInferBrowseClassic = () => {
    const logObjectType = `${this.props.membershipType}_${this.props.loggingLocation}`;
    const logActionType = `${this.props.loggingLocation}_browse_classic`;

    this.logInferAction(logObjectType, logActionType);
  };

  backToClassicPDPHref() {
    return Routes.PDP.RouteById(this.props.product.id) + "?lens=classic";
  }

  renderTitle() {
    if (!this.props.title) {
      return;
    }
    return (
      <div
        className="membership-acquisition-messaging__title"
        dangerouslySetInnerHTML={{ __html: this.props.title }}></div>
    );
  }

  renderDek() {
    if (!this.props.dek) {
      return;
    }
    return <p className="membership-acquisition-messaging__dek">{this.props.dek}</p>;
  }

  renderListItems() {
    return _.map(this.props.list, function (item, index) {
      return (
        <li className="membership-acquisition-messaging__list-item" key={index}>
          <div className="membership-acquisition-messaging__list-item-icon"></div>
          <div className="membership-acquisition-messaging__list-item-text">{item}</div>
        </li>
      );
    });
  }

  renderList() {
    if (!this.props.list) {
      return;
    }
    return <ul className="membership-acquisition-messaging__list">{this.renderListItems()}</ul>;
  }

  renderPromo() {
    if (!this.props.promo) {
      return;
    }
    return <p className="membership-acquisition-messaging__dek promo">{this.props.promo}</p>;
  }

  setSubscriptionIntent(logPixel) {
    switch (this.props.membershipType) {
      case membershipLens.unlimited:
        RentalOptionIntent.setLastIntent(RentalOptions.NONE, ActionsTaken.DRAWER_GRID_UNLIMITED_CTA, "grid");
        break;
      case membershipLens.RTRUpdate:
        RentalOptionIntent.setLastIntent(RentalOptions.NONE, ActionsTaken.DRAWER_GRID_UPDATE_CTA, "grid");
        break;
    }
    logPixel();
  }

  setReserveIntent(logPixel) {
    if (this.props.dispatch) {
      this.props.dispatch(ProductsActions.updateMembershipLens(membershipLens.classic, false));
    }
    RentalOptionIntent.setLastIntent(RentalOptions.RESERVE, ActionsTaken.RESERVE_WAYFINDER, "grid");
    logPixel();
  }

  renderCTA() {
    if (!this.props.cta || !this.props.addToBagUrl) {
      return;
    }

    const ctaHref = this.props.primaryCtaAddsToBag ? this.props.addToBagUrl : this.props.primaryCtaUrl;
    const logPixel = this.props.hasSkuInBag ? this.handleLogInferCheckoutWithSku : this.handleLogInferTryMembership;

    return (
      <a
        className="membership-acquisition-messaging__cta btn"
        href={addQueryParam(ctaHref, "source=membership_drawer")}
        onClick={() => {
          this.setSubscriptionIntent(logPixel);
        }}>
        {this.props.cta}
      </a>
    );
  }

  renderSecondaryCTA() {
    if (!this.props.url || !this.props.secondaryCta) {
      return;
    }

    const logPixel = this.handleLogInferLearnMore;

    return (
      <p className="membership-acquisition-messaging__learn-more">
        <a
          className="title"
          href={this.props.url}
          onClick={() => {
            this.setSubscriptionIntent(logPixel);
          }}>
          {this.props.secondaryCta}
        </a>
      </p>
    );
  }

  renderClassicWayfinder() {
    if (productIsHomeGood(this.props.product)) {
      return null;
    }

    const logPixel = this.handleLogInferBrowseClassic;

    return (
      <div className="membership-acquisition-messaging__wayfinder">
        Looking to rent this for a specific date?{" "}
        <a
          href={this.backToClassicPDPHref()}
          onClick={() => {
            this.setReserveIntent(logPixel);
          }}>
          Try RTR Reserve
        </a>
      </div>
    );
  }

  render() {
    return (
      <div className="membership-acquisition-messaging">
        {this.renderTitle()}
        {this.renderDek()}
        {this.renderList()}
        {this.renderPromo()}
        {this.renderCTA()}
        {this.renderSecondaryCTA()}
        {this.renderClassicWayfinder()}
      </div>
    );
  }
}

MembershipAcquisitionMessaging.propTypes = propTypes;
MembershipAcquisitionMessaging.defaultProps = defaultProps;
